import * as React from 'react';
import * as _ from 'lodash';
import VirtualList from 'react-tiny-virtual-list';
import { Link } from 'react-router-dom';

import * as DetailFormCommon from './common';
import { NavigationLinks } from '../../common/navigation';
import { Formatters } from '../../common/formatters';

export const InventoryDetailFormComponentDetailsShortcuts = ({
    appText,
    handleFormInputChange,
    handleSubmitForm,
    handleSaveChanges,
    handleLinkNavigation,
    numFormChanges,
    formData,
    allComponents,
    currentInventoryItem,
    currentInventoryId,
    defaultInputProps,
    defaultBoxHeight,
    sectionTitle,
    ...rest }) => {
    if (!appText || !formData) { return (<div />); }

    const assocId = _.get(formData, 'associationId', 0);

    const definedComponents = _.reject(allComponents, (o) => Formatters.getInt(o, 'componentId') === 0 || Formatters.getInt(o, 'inventoryId') === currentInventoryId);

    if (_.size(definedComponents) <= 0) { return (<div />); }

    const shortcuts = (_.size(definedComponents)) ?
        _.map(definedComponents, (c, i) => {
            const invId = _.get(c, 'inventoryId', 0);
            const invLink = NavigationLinks.associationInventoryDetail(assocId, invId);
            const componentCustomName = (_.get(c, 'componentName') && _.get(c, 'componentName') !== _.get(c, 'component.name')) ?
                _.get(c, 'componentName') : _.get(c, 'component.name');

            const linkText = `${_.get(c, 'componentId', '0')} - ${componentCustomName}`;

            return (
                <Link
                    onClick={(e) => {
                        handleLinkNavigation(e, invId, invLink);
                        e.preventDefault();
                    }}
                    key={invId}
                    title={linkText}
                    to={invLink}
                >
                    {linkText}
                </Link>
            );
        }) : (<div />);

    return (
        <DetailFormCommon.InventoryDetailFormSection title={sectionTitle}>
            <div className="list-shortcuts">
                <VirtualList
                    height={defaultBoxHeight ? defaultBoxHeight : 80}
                    itemCount={_.size(allComponents)}
                    itemSize={22}
                    className="virtual-list-shortcuts"
                    renderItem={(i) => (
                        <div className="virtual-list-shortcut-container" style={i.style} key={i.index}>{shortcuts[i.index]}</div>
                    )}
                />
            </div>
        </DetailFormCommon.InventoryDetailFormSection>
    );
};



// WEBPACK FOOTER //
// ./src/inventory/detail-form/component-details-shortcuts.tsx